import { createSelector } from 'reselect';
import { ModuleType } from '../../types/modules';
import { AppState } from '../../types/store';
import {
  getDeviationById,
  getDeviationsByIds,
} from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { getModuleDataByModuleName } from '@wix/da-gruser-shared/pkg/redux/selectors/modules';
import { getProfileGruser } from './users';

export const getModuleData = createSelector(
  getProfileGruser,
  state => state,
  (profileGruser, state) => getModuleDataByModuleName(state as any, profileGruser, ModuleType.TIERS)
);

export const getSelectedTierContentType = (state: AppState) =>
  state.subscriptionsSection?.tierContentType;

export const getSelectedTierEntityId = (state: AppState) =>
  state.subscriptionsSection?.selectedTierEntityId;

export const getTierById = (state: AppState, tierEntityId?: any) =>
  tierEntityId ? getDeviationById(state, tierEntityId) : undefined;

export const getSelectedTier = createSelector(
  getSelectedTierEntityId,
  state => state,
  (selectedTierEntityId, state) => getTierById(state, selectedTierEntityId)
);

export const getTiers = createSelector(
  getModuleData,
  state => state,
  (moduleData, state) => getDeviationsByIds(state, moduleData?.tiers || [])
);

export const hasTiers = createSelector(getTiers, tiers => tiers.length > 0);

export const hasPublishedTiers = createSelector(getTiers, tiers =>
  tiers.some(tier => tier.isPublished)
);

export const getFirstTier = createSelector(getTiers, tiers => tiers?.[0]);

export const getSelectedOrFirstTier = createSelector(
  getSelectedTier,
  getFirstTier,
  (selectedTier, firstTier) => selectedTier || firstTier
);

export const getSubscriptionsStats = (state: AppState) => state.subscriptionsSection?.stats;

export const getSubscriptionsChartData = (state: AppState) => state.subscriptionsSection?.chartData;
